import React, {useEffect, useState} from 'react'
import ModalForm from "../../../../components/modalComponents/ModalForm";
import {KEYS_LICENCIAS} from "./LicenciasContantes";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import {
    getSolicitudLicenciaToEditAPI,
    updateSolicitudLicenciaCondicionAPI
} from "../../../../consumers/backendApisUrls";
import LicenciaCondicion from "./LicenciaCondicion";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {DetalleLicenciasCondicionActions} from "./DetalleLicenciasCondicionActions";
import useDidMountEffect from "../../../../hooks/useDidMountEffect/useDidMountEffect";

const DetalleLicenciaCondicion = ({toggleModal, currentIdEmpleado, fromAdminPage, idCondicion, manageSearch}) => {
    const SECTION_NAME = "DetalleLicenciaCondicion";
    const [formValuesLicencias, setFormValuesLicencias] = useState({});
    const [originalFormValuesLicencias, setOriginalFormValuesLicencias] = useState({});
    const [executeManagePost] = useManagePostRequest();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();
    const [isUploading, setIsUploading] = useState(false);
    const [isEditable, setIsEditable] = useState(false);

    const [initLoaded, setInitLoaded] = useState(false);

    const [haSidoEditado, setHaSidoEditado] = useState(false);
    const [tipoLicenciaHaSidoEditado, setTipoLicenciaHaSidoEditado] = useState(false);
    const [togglePreviewFromMainModal, setTogglePreviewFromMainModal] = useState(false);
    const keysToWatch = [
        'IdTipoLicenciaCondicion',
        'FechaInicioCondicion',
        'FechaFinCondicion',
        'HoraFin',
        'HoraInicio',
        'MotivoSolicitud'
    ];

    const hasChanged = (a, b, keys) => {
        for (let key of keys) {
            if (a[key] !== b[key]) return true;
        }
        return false;
    };


    const init = async () => {
        const payload = {
            IdCondicion: idCondicion
        }
        await executeManagePost(getSolicitudLicenciaToEditAPI(), payload, succesGetSolicitudLicenciaToEditAPICallback);
        setInitLoaded(true);
    }

    const succesGetSolicitudLicenciaToEditAPICallback = ({data}) => {
        setFormValuesLicencias({...data});
        setOriginalFormValuesLicencias({...data});
        if (fromAdminPage === true) {
            setIsEditable(data?.PuedeActualizarSolicitudLicenciaFromAdminPage === true);
        } else {
            setIsEditable(data?.PuedeActualizarSolicitudLicenciaFromColaboradorPage === true);
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = updateSolicitudLicenciaCondicionAPI();
        payload = {...formValuesLicencias, IdCondicion: idCondicion, FromAdminPage: fromAdminPage};
        keys = KEYS_LICENCIAS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitCallback);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleUpdateFromPreview = async (e) => {
        e && e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = updateSolicitudLicenciaCondicionAPI();
        payload = {...formValuesLicencias, IdCondicion: idCondicion, FromAdminPage: fromAdminPage};
        keys = KEYS_LICENCIAS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successhandleUpdateFromPreviewCallback);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }

    }

    const successhandleUpdateFromPreviewCallback = async (response) => {
        await init();
        setHaSidoEditado(false);
        setTogglePreviewFromMainModal(!togglePreviewFromMainModal);
    }

    const successSubmitCallback = async () => {
        toggleModal();
        manageSearch();
    }

    useEffect(() => {
        init();
    }, []);

    useDidMountEffect(() => {
        if (initLoaded===true){
            let haCambiado = hasChanged(originalFormValuesLicencias, formValuesLicencias, keysToWatch);
            setHaSidoEditado(haCambiado);

            let haCambiadoTipoLicencia = hasChanged(originalFormValuesLicencias, formValuesLicencias, [KEYS_LICENCIAS.IdTipoLicenciaCondicion]);
            setTipoLicenciaHaSidoEditado(haCambiadoTipoLicencia)
        }

    }, [formValuesLicencias]);



    return (
        <ModalForm titulo="Ver Detalle Licencia"
                   width="1100px"
                   showModal={toggleModal}
                   // isSubmitting={isSubmitting}
                   hasSaveButton={false}
        >
            <div className="displayFlexWrap">
                <LicenciaCondicion
                    SECTION_NAME={SECTION_NAME}
                    idEmpleado={currentIdEmpleado}
                    formValuesLicencias={formValuesLicencias}
                    setFormValuesLicencias={setFormValuesLicencias}
                    KEYS={KEYS_LICENCIAS}
                    fromAdminPage={fromAdminPage}
                    isCreate={false}
                    isEditable={isEditable}

                    showConfirmarActualizarBeforePreview={haSidoEditado}
                    handleUpdateFromPreview={handleUpdateFromPreview}
                    togglePreviewFromMainModal={togglePreviewFromMainModal}
                    tipoLicenciaHaSidoEditado={tipoLicenciaHaSidoEditado}
                />
            </div>
            {isEditable &&
                <div className="d-flex justify-content-between mt-1 align-items-center">
                    <p className="mb-0 mr-2 red-below-modal-message" style={{fontSize: "13px", fontWeight: "600"}}>
                        <strong>Nota:</strong> Si no está de acuerdo, EDITE la información, habiendo coordinado previamente con el solicitante y asegurándose de que los datos registrados guarden relación con el documento de sustento.
                    </p>
                    <button
                        type="button"
                        className="mr-3 mb-1 btn btn-primary generic-button-ficha-modal generic-button-hover-azul"
                        disabled={isUploading || isSubmitting}
                        onClick={handleSubmit}
                    >
                        Actualizar
                    </button>
                </div>
            }

            {(isEditable || fromAdminPage) && <DetalleLicenciasCondicionActions
                idCondicion={formValuesLicencias["IdCondicion"]}
                item={`${formValuesLicencias["NombreEmpleado"]} - ${formValuesLicencias["TipoDeCondicion"]}`}
                refreshMainPage={manageSearch}
                toggleMainModal={toggleModal}
                formValues={formValuesLicencias}

            />
            }


        </ModalForm>
    )
}

export default DetalleLicenciaCondicion;